import { useEffect, useRef } from 'react'

import { useQuery } from '@apollo/client'
import { useRouter } from 'next/router'

import { useQueryParams } from '@/context/queryParamsContext'
import { GET_PUBLIC_PROJECT } from '@/modules/projects/graphQL'

import {
  PublicProjectUiQuery,
  PublicProjectUiQueryVariables,
} from 'types/api.graphql'

type Params = {
  projectId: string
}

export const usePublicProject = (
  manualProjectId?: string,
  callback?: (project: PublicProjectUiQuery['publicProject']) => void
) => {
  const router = useRouter()
  const hasCalledBack = useRef(false)
  const { params } = useQueryParams<Params>()

  const projectId =
    manualProjectId || params?.projectId || router.query?.projectId?.toString()

  const { data, loading } = useQuery<
    PublicProjectUiQuery,
    PublicProjectUiQueryVariables
  >(GET_PUBLIC_PROJECT, {
    variables: { projectId },
    skip: !projectId,
    fetchPolicy: 'cache-and-network',
  })

  // would ideally be done via the onCompleted callback but that doesn't fire when it's a cache hit
  useEffect(() => {
    if (data?.publicProject?.id) {
      if (!!callback && !hasCalledBack.current) {
        callback(data.publicProject)
        hasCalledBack.current = true
      }
    }
  }, [callback, data?.publicProject])

  return {
    publicProject: data?.publicProject,
    loading,
    projectId,
  }
}
